import React, { useState, useEffect, useCallback, useRef } from 'react';
import { MdAdd, MdSave } from 'react-icons/md';
import { Form } from '@unform/web';
import produce from 'immer';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import ListContext from './context';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Load from '~/components/Load';
import List from '~/components/List';

import {
  Container,
  Table,
  PageActions,
  Menus,
  NewButton,
  SemDados,
} from './styles';

export default function CadenciaEdit({ match }) {
  const inputRef = useRef(null);
  const [id, setId] = useState(0);
  const [dado, setDado] = useState([]);
  const [page, setPage] = useState(1);
  const [tentativas, setTentativas] = useState([]);
  const [visible, setVisible] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);

  const getTentativa = useCallback(async () => {
    setLoading(true);
    const { id: ids } = match.params;
    const tent = await api.get(`/cadencia/${ids}/tentativa`);
    setTentativas(tent.data);
    setLoading(false);
  }, [match.params]);

  useEffect(() => {
    async function getDados() {
      setLoading(true);
      const { id: ids } = match.params;
      const response = await api.get(`/cadencia/${ids}`);
      setDado(response.data);
      setId(ids);
      setLoading(false);
    }
    getTentativa();
    getDados();
  }, [getTentativa, match]);

  /**
   * Funçao para editar a ordem das tentativas
   */

  async function move(from, to) {
    setTentativas(
      produce(tentativas, draft => {
        const dragged = draft[from];

        draft.splice(from, 1);
        draft.splice(to, 0, dragged);
      })
    );

    setVisible(true);
  }

  /**
   * Funcoes
   */

  async function hanlderSalvar() {
    tentativas.map(async (tentativa, index) => {
      try {
        await api.put(`/cadencia/${id}/ordem/${tentativa.id}`, {
          tentativa: index + 1,
        });
      } catch (error) {
        toast.error('Erro ao salvar ordem');
      }
    });
    toast.success('Ordem salva com sucesso');
    getTentativa();
    setVisible(false);
  }

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/cadencia/${dado.id}`, {
        name: data.name,
      });

      toast.success('Cadencia editada com sucesso');
      history.push('/cadencia');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar cadencia, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handlePage(action) {
    await setPage(action === 'back' ? page - 1 : page + 1);
  }

  async function handleCreate() {
    history.push(`/tentativa-create/${id}`);
  }

  if (loading) {
    return <Load />;
  }

  return (
    <ListContext.Provider value={{ tentativas, move }}>
      <Container>
        <h4>Cadastrar Cadência</h4>
        <Card>
          <Form
            ref={inputRef}
            initialData={dado}
            onSubmit={handlerSubmit}
            autoComplete="off"
          >
            <Input icon="MdRepeat" label="Nome" name="name" type="text" />
            <Button tamanho="40px" load={carregar}>
              Editar
            </Button>
          </Form>
        </Card>
        <h4>Lista de Tentativas</h4>
        <Card>
          <Menus>
            <NewButton type="button" onClick={handleCreate}>
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
            {visible && (
              <NewButton type="button" onClick={hanlderSalvar}>
                <MdSave size={16} color="#FFF" />
                Salvar
              </NewButton>
            )}
          </Menus>
          {tentativas.length <= 0 ? (
            <SemDados>
              <h2>Sem dados</h2>
            </SemDados>
          ) : (
            <>
              <Table>
                <thead>
                  <tr>
                    <th>Tentativa</th>
                    <th>Tipo</th>
                    <th>Tempo</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {tentativas.map((tentativa, index) => (
                    <List
                      data={tentativa}
                      id={id}
                      index={index}
                      key={tentativa.id}
                    />
                  ))}
                </tbody>
              </Table>
              <PageActions>
                <button
                  type="button"
                  disabled={page < 2}
                  onClick={() => handlePage('back')}
                >
                  Anterior
                </button>
                <span>Página {page}</span>
                <button
                  type="button"
                  disabled={tentativas.length < 10}
                  onClick={() => handlePage('next')}
                >
                  Próximo
                </button>
              </PageActions>
            </>
          )}
        </Card>
      </Container>
    </ListContext.Provider>
  );
}

CadenciaEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
